var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentCompletedSigningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.404,
    cy: 52.929,
    r: 52.929,
    fill: "#E8F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "M67.067 82C75.314 82 82 75.314 82 67.067c0-8.248-6.686-14.934-14.933-14.934-8.248 0-14.934 6.686-14.934 14.934C52.133 75.314 58.82 82 67.067 82Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00A3FA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    d: "m73.722 62.726-7.23 9.64a1.87 1.87 0 0 1-2.815.201l-3.733-3.733M33.467 40.933H59.6m-26.133 11.2H48.4m-14.933 11.2H42.8m0 11.2H29.733A3.733 3.733 0 0 1 26 70.8V29.733A3.733 3.733 0 0 1 29.733 26h26.455c.99 0 1.938.393 2.638 1.093l7.148 7.148a3.73 3.73 0 0 1 1.093 2.638V42.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCompletedSigningIcon);
export default __webpack_public_path__ + "static/media/document-completed-signing-icon.1c1730a21d12c8ad4ccb9daea0e0ee0d.svg";
export { ForwardRef as ReactComponent };